<template>
  <div class="mainCamsSetting">
    <setting-header />
    <v-divider class="mainCamsSetting_header-divider" />
    <template v-for="(item, index) in list">
      <div
        :key="`mainCamsSetting_item-${index}`"
        v-ripple
        class="mainCamsSetting_item"
        @click="
          navigateTo({ name: 'settings-cams-list', params: { group: item.id } })
        "
      >
        <h3>カメラグループ一覧</h3>
        <span class="mainCamsSetting_item-desc"
          >カメラをグループに分けて登録</span
        >
      </div>
      <v-divider :key="`mainCamsSetting_item-div-${index}`" />
    </template>
  </div>
</template>

<script>
import SettingHeader from '../SettingHeader.vue';

export default {
  name: 'MainCamsSetting',
  components: {
    SettingHeader,
  },
  data() {
    return {
      list: [
        {
          name: 'カメラグループ一覧',
          desc: 'カメラをグループに分けて登録',
          id: 1,
        },
        // {
        //   name: 'カメラグループの閲覧権限',
        //   desc: 'ユーザーごとにカメラの閲覧権限を設定する',
        //   id: 2,
        // },
      ],
    };
  },
  methods: {
    navigateTo(to) {
      this.$router.push(to);
    },
  },
};
</script>

<style lang="scss">
.mainCamsSetting {
  &_header-divider {
    margin-top: 15px;
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
  }
}
</style>
